if (!customElements.get('pdp-urgency')) {
  class PdpUrgency extends HTMLElement {
    connectedCallback() {
      this.countEl = this.querySelector('.js-pdp-viewing-count');
      if (!this.countEl) return;

      const min = parseInt(this.dataset.min, 10) || 10;
      const max = parseInt(this.dataset.max, 10) || 99;
      const intervalSeconds = parseInt(this.dataset.interval, 10);
      this.intervalMs = (Number.isFinite(intervalSeconds) ? intervalSeconds : 5) * 1000;

      const maxStep = parseInt(this.dataset.step, 10);
      this.maxStep = Number.isFinite(maxStep) ? maxStep : 10;

      let current = Math.floor(Math.random() * (max - min + 1)) + min;

      this.updateCount = () => {
        const delta = Math.floor(Math.random() * (this.maxStep + 1));
        const direction = Math.random() < 0.5 ? -1 : 1;
        current = Math.min(max, Math.max(min, current + delta * direction));
        this.countEl.textContent = current;
      };

      this.updateCount();
      this.timer = window.setInterval(this.updateCount, this.intervalMs);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }
  }

  customElements.define('pdp-urgency', PdpUrgency);
}
